export default __webpack_public_path__ + "static/media/IMG-20240822-WA0012.bb378f50.jpg";